import { styled } from '@linaria/react'
import { getThemeSpacing } from '../styles/appTheme'
import { palette } from '../styles/colors'

export const StyledTopic = styled('p')`
    margin-top: 1px;
    font-size: 9px;
    font-weight: 500;
    line-height: 1.25;
    word-break: break-all;
    max-height: 45px;
    color: ${palette.secondaryText};
`

export const StyledModelName = styled('span')`
    font-size: 14px;
    font-weight: 600;
`

export const StyledMediaContainer = styled('div')`
    flex: 1 0 auto;
    margin: auto 0;
`

export const StyledDetailsContainer = styled('div')`
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 90px;
    padding-left: 5px;
    color: ${palette.secondaryText};
`

export const StyledContainer = styled('article')`
    padding-right: ${getThemeSpacing(1)};
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    cursor: pointer;
`

export const StyledRoot = styled('section')`
    width: 100%;
    max-width: 100%;
`
